import React from 'react';
import groupIcon from '../../assets/icons/group-icon.svg';
import endorsementIcon from '../../assets/icons/endorsement-icon.svg';
import groupIcon2 from '../../assets/icons/group-icon-2.svg';

interface HowItWorksSectionProps {
  onSignInClick: () => void;
}

const HowItWorksSection: React.FC<HowItWorksSectionProps> = ({ onSignInClick }) => {
  return (
    <div
      className="relative w-full bg-white py-12 md:py-16 lg:py-20"
      data-name="How It Works Section"
      id="node-12_9734"
    >
      <div
        className="relative w-full px-6 sm:px-8 md:px-12"
        data-name="How It Works Section"
        id="node-12_9804"
      >
        <div
          className="flex flex-col gap-8 md:gap-12 items-center justify-start mx-auto max-w-[1279px]"
          data-name="How It Works Content"
          id="node-12_9805"
        >
          <h2
            className="font-['Ovo',_serif] text-[28px] sm:text-[32px] md:text-[40px] lg:text-[48px] text-center uppercase text-[#1f1f1f] leading-tight"
            id="node-12_9806"
          >
            How CLOUT Works
          </h2>
          <div
            className="flex flex-col lg:flex-row gap-8 md:gap-12 lg:gap-8 xl:gap-12 items-stretch justify-center w-full"
            data-name="How It Works Steps"
            id="node-12_9807"
          >
            <div className="flex items-stretch justify-center w-full lg:w-1/3">
              <div
                className="flex flex-col gap-6 md:gap-8 items-center justify-start w-full max-w-[350px] h-full"
                data-name="Step Content"
                id="node-12_9808"
              >
                <div
                  className="bg-[#f8f6f2] flex items-center justify-center w-[120px] h-[120px] sm:w-[140px] sm:h-[140px] md:w-[160px] md:h-[160px] lg:w-[181px] lg:h-[181px] rounded-full"
                  data-name="noun-endorsement-7874456"
                  id="node-12_9809"
                >
                  <div
                    className="box-border content-stretch flex flex-row gap-2 items-center justify-center p-0 relative shrink-0 w-[53px]"
                    data-name="Frame"
                    id="node-12_9824"
                  >
                    <div
                      className="h-[53px] relative shrink-0 w-[37.856px]"
                      data-name="Group"
                      id="node-12_9825"
                    >
                      <img
                        alt=""
                        className="block max-w-none size-full"
                        loading="lazy"
                        src={groupIcon}
                      />
                    </div>
                  </div>
                </div>
                <div
                  className="box-border content-stretch flex flex-col gap-3 items-start justify-start leading-[0] p-0 relative shrink-0 text-[#1f1f1f] text-center w-full"
                  id="node-12_9828"
                >
                  <h3
                    className="font-['Ovo',_serif] text-[18px] sm:text-[20px] md:text-[24px] lg:text-[28px] text-center uppercase text-[#1f1f1f] leading-tight"
                    id="node-12_9829"
                  >
                    DO YOU HAVE CLOUT?
                  </h3>
                  <p
                    className="font-['Ovo',_serif] font-normal text-[14px] sm:text-[15px] md:text-[16px] lg:text-[18px] text-center text-[#1f1f1f] leading-relaxed"
                    id="node-12_9830"
                    style={{
                      fontVariationSettings: "'wdth' 100",
                    }}
                  >
                    Find your score. Join the movement. We combine reviews, education, experience
                    and online presence into one powerful metric: The CLOUT Score.
                  </p>
                </div>
              </div>
            </div>
            <div className="flex items-stretch justify-center w-full lg:w-1/3">
              <div
                className="flex flex-col gap-6 md:gap-8 items-center justify-start w-full max-w-[350px] h-full"
                data-name="Step Content"
                id="node-12_9831"
              >
                <div
                  className="w-[120px] h-[120px] sm:w-[140px] sm:h-[140px] md:w-[160px] md:h-[160px] lg:w-[181px] lg:h-[181px]"
                  data-name="noun-endorsement-7874456"
                  id="node-12_9832"
                >
                  <img
                    alt=""
                    className="block max-w-none size-full"
                    loading="lazy"
                    src={endorsementIcon}
                  />
                </div>
                <div className="flex flex-col gap-3 text-center w-full" id="node-12_9848">
                  <h3
                    className="font-['Ovo',_serif] text-[18px] sm:text-[20px] md:text-[24px] lg:text-[28px] text-center uppercase text-[#1f1f1f] leading-tight"
                    id="node-12_9849"
                  >
                    SIGN UP & GET CERTIFIED
                  </h3>
                  <p
                    className="font-['Ovo',_serif] font-normal text-[14px] sm:text-[15px] md:text-[16px] lg:text-[18px] text-center text-[#1f1f1f] leading-relaxed"
                    id="node-12_9850"
                    style={{ fontVariationSettings: "'wdth' 100" }}
                  >
                    Submit your credentials. CLOUT verifies them to build your professional profile.
                  </p>
                </div>
              </div>
            </div>
            <div className="flex items-stretch justify-center w-full lg:w-1/3">
              <div
                className="flex flex-col gap-6 md:gap-8 items-center justify-start w-full max-w-[350px] h-full"
                data-name="Step Content"
                id="node-12_9851"
              >
                <div
                  className="bg-[#f8f6f2] flex items-center justify-center w-[120px] h-[120px] sm:w-[140px] sm:h-[140px] md:w-[160px] md:h-[160px] lg:w-[181px] lg:h-[181px] rounded-full"
                  data-name="noun-endorsement-7874456"
                  id="node-12_9852"
                >
                  <div
                    className="overflow-clip relative shrink-0 size-[53px]"
                    data-name="noun-success-5872134"
                    id="node-12_9853"
                  >
                    <div
                      className="absolute bottom-[-0.158%] contents left-[9.434%] right-[11.399%] top-[5.346%]"
                      data-name="Group"
                      id="node-12_9854"
                    >
                      <div
                        className="absolute bottom-[-0.158%] left-[9.434%] right-[11.399%] top-[5.346%]"
                        data-name="Group"
                        id="node-12_9855"
                      >
                        <div className="absolute bottom-[-0.995%] left-[-1.192%] right-[-1.192%] top-[-0.995%]">
                          <img
                            alt=""
                            className="block max-w-none size-full"
                            loading="lazy"
                            src={groupIcon2}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="flex flex-col gap-3 text-center w-full" id="node-12_9877">
                  <h3
                    className="font-['Ovo',_serif] text-[18px] sm:text-[20px] md:text-[24px] lg:text-[28px] text-center uppercase text-[#1f1f1f] leading-tight"
                    id="node-12_9878"
                  >
                    ENDORSE EXCELLENCE
                  </h3>
                  <p
                    className="font-['Ovo',_serif] font-normal text-[14px] sm:text-[15px] md:text-[16px] lg:text-[18px] text-center text-[#1f1f1f] leading-relaxed"
                    id="node-12_9879"
                    style={{ fontVariationSettings: "'wdth' 100" }}
                  >
                    Get endorsed & give endorsements to build your CLOUT.
                  </p>
                </div>
              </div>
            </div>
          </div>
          <button
            className="relative inline-flex items-center justify-center px-8 py-4 min-h-[52px] border-2 border-[#1f1f1f] hover:bg-[#1f1f1f] transition-all duration-200 cursor-pointer group w-full sm:w-auto max-w-sm mx-auto"
            data-name="Button"
            id="node-12_9880"
            onClick={onSignInClick}
          >
            <span
              className="font-['Ovo',_serif] text-[16px] sm:text-[18px] md:text-[20px] text-[#1f1f1f] uppercase group-hover:text-white transition-colors"
              id="node-I12_9880-315_4669"
            >
              JOIN THE MOVEMENT
            </span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default HowItWorksSection;
